import React from 'react'

import HHConfirmDialog from 'components/common/HHConfirmDialog'
import T from 'T'

interface RegenerateDraftInvoicesDialogProps {
  isOpen?: boolean
  isLoading?: boolean
  onConfirm: () => void
  onClose: () => void
}

/**
 * Asks the user whether to regenerate the account's draft invoices so a payment-terms /
 * billing-profile change takes effect on them. Driven by `useRegenerateDraftInvoicesPrompt`.
 */
const RegenerateDraftInvoicesDialog = ({ isOpen = false, isLoading = false, onConfirm, onClose }: RegenerateDraftInvoicesDialogProps) => (
  <HHConfirmDialog
    cancelButtonTitle={T.DISMISS}
    ConfirmButtonProps={{ color: 'primary', loading: isLoading }}
    confirmButtonTitle={T.YES}
    confirmDescription={T.REGENERATE_DRAFT_INVOICES_PROMPT}
    confirmTitle={T.REGENERATE_DRAFT_INVOICES_TITLE}
    DialogProps={{ maxWidth: 'xs', fullWidth: true }}
    isOpen={isOpen}
    onClose={onClose}
    onConfirm={onConfirm}
  />
)

export default RegenerateDraftInvoicesDialog
